<div class="container__content main container">
  <div class="table_box">
    <h2>{{ 'ERROR.404.header' | alpitranslate }}</h2>
    <p [innerHTML]="'ERROR.404.paragraph' | alpitranslate: { mail_address: mail }"></p>
    <p>
      {{ 'ERROR.404.products' | alpitranslate: { productname: productname } }}
    </p>
    <ul>
      <li><a [routerLink]="['/SKIHIREENTRY'] | localize">Ski hire</a></li>
      <li><a [href]="['/SKISCHOOLENTRY'] | localize">Ski schools</a></li>
    </ul>
    <p></p>
  </div>
</div>
